import { render, staticRenderFns } from "./Watermark.vue?vue&type=template&id=505e1b06&scoped=true&"
import script from "./Watermark.vue?vue&type=script&lang=ts&"
export * from "./Watermark.vue?vue&type=script&lang=ts&"
import style0 from "./Watermark.vue?vue&type=style&index=0&id=505e1b06&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "505e1b06",
  null
  
)

export default component.exports